import { j as a } from "../jsx-runtime-Wav_3Wde.js";
import "../index.esm-DOxVcNnO.js";
import "styled-components";
import "styled-system";
import i from "../Icon/Icons/ASOSIcon.mjs";
import "../Icon/StyledPath.mjs";
import { a as p, c as s } from "../brands-CoixlYYY.js";
import { useBrand as e } from "../providers/BrandProvider/brandProvider.mjs";
import d from "./LoadingSpinner.mjs";
const f = {
  [s]: i
}, I = ({ brandConfig: o = f, allowList: r = p, ...n }) => {
  const t = e(r), m = o[t];
  return /* @__PURE__ */ a.jsx(d, {
    theme: null,
    Icon: m,
    ...n
  });
};
export {
  I as default
};
